import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';

const getStatsBreadcrumbs = (query?: IQueryParams): IBreadcrumb[] => ([
  getMarketOverviewBreadcrumbsRoute(query),
  {
    title: 'Stats',
    isActive: true,
  },
]);

export default getStatsBreadcrumbs;
